import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import * as actions from "../../store/actions/index";
import { connect } from "react-redux";
import Table from "@material-ui/core/Table";
import { Redirect, withRouter } from "react-router-dom";
import TableBody from "@material-ui/core/TableBody";
import CircularProgress from "@material-ui/core/CircularProgress";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Grid from '@material-ui/core/Grid';
import PropTypes from "prop-types";
import ArbitratorAcceptRejectBox from "../NavTabs/ArbitratorAcceptRejectBox";
import AdminAcceptRejectBox from "../NavTabs/AdminAcceptRejectBox";
import ChooseArbitratorAdmin from "../Onboarding/ChooseArbitratorAdmin";
import ChooseArbitratorForCaseInformation from "./ChooseArbitratorForCaseInformation";
import ArbitratorAppointed from './ArbitratorAppointed'
import TimerPanel from "./TimerPanel"
import LoginRecords from "./LoginRecords"
import SMSStatus from "./SMSStatus"
import EmailReadStatus from "./EmailReadStatus"
import SentEmailStatus from "./SentEmailStatus"
import DeadlinePanel from "./DeadlinePanel"
import SelectedArbitrators from "./SelectedArbitrators";
import leftIcon from '../../images/left.png'
import Button from "@material-ui/core/Button";

const styles = (theme) => ({
  textColor: {
    color: "#a52423",
  },
  divStyle: {
    paddingTop: "15px",
    width: "100vw",
    '@media (max-width: 780px)': {
        width: '100vw'
      }
    
  },
  padding: {
    padding: "10px",
  },
  subText: {
    color: "#a52423",
    paddingLeft: "30px",
    fontSize: "14px",
  },
  table: {
    width: "60%",
  },
  link: {
    textDecoration: "none",
  },
  header: {
    fontSize: 13,
    border: "none",
  },
  row: {
    fontSize: 13,
    //borderRight: '0.1em solid rgba(224, 224, 224, 1)',
    border: "none",
    wordBreak:'keep-all'
  },
  rowBold: {
    fontSize: 14,
    fontWeight: "bold",
    //borderRight: '0.1em solid rgba(224, 224, 224, 1)',
    border: "none",
  },
});

class CaseInformation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      typeOfAccount: localStorage.getItem("typeOfAccount"),
    };

    // this.props.getCaseInfo(
    //   localStorage.getItem("caseId"),
    //   localStorage.getItem("token")
    // );
    // console.log(this.props);
  }

  componentDidMount() {
    // console.log('caseinfo this.props: '+JSON.stringify(this.props))
    // this.props.getUserInformation(localStorage.getItem('token'));
    // this.props.getCaseInfo(
    //   localStorage.getItem("caseId"),
    //   localStorage.getItem("token")
    // );

    this.checkLanguage()
  }

  checkLanguage = function() {
    try{
      if (this.props.isLoading){
        setTimeout(()=>{this.checkLanguage()},100)
      }
      else{
        console.log('this caseData: '+JSON.stringify(this.props.caseData))
        var lang = localStorage.getItem('language');
        if (this.props !== undefined){
          if (this.props.caseData !== undefined){
            if (this.props.caseData.language !== undefined){
              if (this.props.caseData.language == 'Chi'){
                if (lang == 'en' || lang == undefined){
                  localStorage.setItem('language', 'cn');
                  setTimeout(()=>{
                      window.location.reload();
                  },100)
                }
              }
              else if (this.props.caseData.language == 'Eng'){
                if (lang == 'cn' || lang == undefined){
                  localStorage.setItem('language', 'en');
                  setTimeout(()=>{
                      window.location.reload();
                  },100)
                }
              }
            }
          }
        }
      }
    }catch(err){
      setTimeout(()=>{this.checkLanguage()},100)
    }
  }
  
  componentWillMount() {
    // this.props.getCaseInfo(
    //   localStorage.getItem("caseId"),
    //   localStorage.getItem("token")
    // );
  }

  render() {
    const { classes, isLoading } = this.props;
    var disableUploadDoc = false
    
    if (isLoading) {
      return (
        <CircularProgress size={50} thickness={3} className={classes.progress} />
      );
    } else {
    if (this.props.caseData == undefined) {
      return <Redirect to={`/cases/${localStorage.getItem("caseId")}`} />;
    } else {
      
    var sevenDaysLaterTime = new Date(this.props.caseData.timestampForCaseProcedure)
    sevenDaysLaterTime.setDate(sevenDaysLaterTime.getDate() + 7);
    
    var now = new Date();
    var canChooseArbitrator = true;
    var responseTimestamp;
    
    if (this.props.caseData.response !== undefined){
      responseTimestamp = new Date(this.props.caseData.response.timestampForCaseProcedure)

      var threeDaysLaterTimeAfterResponse = new Date(this.props.caseData.response.timestampForCaseProcedure)
      threeDaysLaterTimeAfterResponse.setDate(threeDaysLaterTimeAfterResponse.getDate() + 3);
      
      if (now >= threeDaysLaterTimeAfterResponse){
        canChooseArbitrator = false
      }

      if (this.props.caseData.requireAdminChooseArbitrator == true){
        canChooseArbitrator = false
      }
      
      if (now < threeDaysLaterTimeAfterResponse){
          var inTn = setInterval(()=>{
              if (now >= threeDaysLaterTimeAfterResponse){
                  canChooseArbitrator = false;
                  clearInterval(inTn)
              }
          })
      } 
    }
    else if (this.props.caseData.response == undefined){
      // console.log('now: '+now)
      // console.log('sevenDaysLaterTime: '+sevenDaysLaterTime)
        // if (now <= sevenDaysLaterTime){
          canChooseArbitrator = false
        // }
    }

    var now = new Date();
    var threeDaysLaterTimeAfterResponse = new Date();
    var responseTimestampFourDaysLater = new Date()
    var responseTimestampDateToSubmitDocuments = new Date()
    var responseTimestampCompleteSubmissionInterrogatoryAndEnquiry = new Date()
    var responseTimestampToAward = new Date()
    var startProceeding = new Date()
    
    if (this.props.caseData.arbitratorStatus !== undefined){
      if (this.props.caseData.arbitratorStatus == 'false' || this.props.caseData.arbitratorStatus  == 'waiting'){
          //if response has been received
          if (this.props.caseData.response !== undefined){
              // then check if three days are over
              threeDaysLaterTimeAfterResponse = new Date(this.props.caseData.response.timestampForCaseProcedure)
              threeDaysLaterTimeAfterResponse.setDate(threeDaysLaterTimeAfterResponse.getDate() + 3);
          }
      }
    }

    if (this.props.caseData.startDateForFurtherProceedings !== undefined){
      
      startProceeding = new Date(this.props.caseData.startDateForFurtherProceedings)
      responseTimestampFourDaysLater = new Date(this.props.caseData.startDateForFurtherProceedings)
      responseTimestampFourDaysLater.setDate(responseTimestampFourDaysLater.getDate() + 4);

      responseTimestampDateToSubmitDocuments = new Date(this.props.caseData.startDateForFurtherProceedings)
      responseTimestampDateToSubmitDocuments.setDate(responseTimestampDateToSubmitDocuments.getDate() + 7);
      
      responseTimestampCompleteSubmissionInterrogatoryAndEnquiry = new Date(this.props.caseData.startDateForFurtherProceedings)
      responseTimestampCompleteSubmissionInterrogatoryAndEnquiry.setDate(responseTimestampCompleteSubmissionInterrogatoryAndEnquiry.getDate() + 11);

      responseTimestampToAward = new Date(this.props.caseData.startDateForFurtherProceedings)
      responseTimestampToAward.setDate(responseTimestampToAward.getDate() + 18);
      
    }
        
        if (this.props.caseData.agreement_type == "EstateAgentDispute") {
          if ( (this.props.caseData.a2 == "purchaser" || this.props.caseData.a2 == "vendor") && this.props.caseData.a1 == undefined ) {
            if (this.props.caseData.namesOfA2 !== undefined) {
              return (
                <div className={classes.divStyle}>
                  {this.state.typeOfAccount == "arbitrator" &&
                    this.props.caseData.arbitratorStatus == "waiting" && (
                      <ArbitratorAcceptRejectBox />
                    )}
                  {this.props.caseData.arbitratorStatus == "true" && (
                      <ArbitratorAppointed caseData={this.props.caseData} claimantArbitratorName={this.props.claimantArbitratorName} AcceptedArbitratorName={this.props.caseData.AcceptedArbitratorName} />
                    )}
                    
                  {this.state.typeOfAccount == "admin" &&
                    this.props.caseData.requireAdminChooseArbitrator ==
                      true && <ChooseArbitratorAdmin />}

                  <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>

                  <Grid container spacing={0}>
                    <Grid item spacing={8} md={6} lg={6} sm={6} xs={12}>
                      <Table className={classes.table}>
                        <TableHead style={{ border: "none" }}>
                          <TableRow style={{ height: 16 }}>
                            <TableCell className={classes.header}></TableCell>
                            <TableCell
                              className={classes.header}
                              align="left"
                            ></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.row}
                              component="th"
                              scope="row"
                            >
                              {this.context.t("Case Number")}:
                            </TableCell>
                            <TableCell className={classes.row} align="left">
                              {this.props.caseData.caseIdName}
                            </TableCell>
                          </TableRow>

                          <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.row}
                              component="th"
                              scope="row"
                            >
                              {this.context.t("Case Date")}:
                            </TableCell>
                            <TableCell className={classes.row} align="left">
                              {new Date(this.props.caseData.timestamp).getFullYear()}-{(new Date(this.props.caseData.timestamp).getMonth()+1).toLocaleString().toString().padStart(2,'0')}-{(new Date(this.props.caseData.timestamp).getDate()).toLocaleString().toString().padStart(2,'0')} {(new Date(this.props.caseData.timestamp).getHours()).toLocaleString().toString().padStart(2,'0')}:{(new Date(this.props.caseData.timestamp).getMinutes()).toLocaleString().toString().padStart(2,'0')}:{(new Date(this.props.caseData.timestamp).getSeconds()).toLocaleString().toString().padStart(2,'0')}
                            </TableCell>
                          </TableRow>

                          {/* <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.row}
                              component="th"
                              scope="row"
                            >
                              {this.context.t("claimantArbitrator")}
                            </TableCell>
                            <TableCell className={classes.row} align="left">
                              {
                                   this.props.caseData.selectedArbitrators !== undefined && this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Claimant') !== -1 && this.props.caseData.selectedArbitrators[this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Claimant')].arbitrator
                                   }
                            </TableCell>
                          </TableRow>

                          <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.row}
                              component="th"
                              scope="row"
                            >
                              {this.props.caseData.selectedArbitrators[this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Respondent')].arbitrator}
                            </TableCell>
                            <TableCell className={classes.row} align="left">
                              {
                                   this.props.caseData.selectedArbitrators !== undefined && this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Respondent') !== -1 && this.props.caseData.selectedArbitrators[this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Respondent')].arbitrator
                                   }
                            </TableCell>
                          </TableRow> */}

                          <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.row}
                              component="th"
                              scope="row"
                            >
                              {this.context.t("claimantArbitrator")}
                            </TableCell>
                            <TableCell className={classes.row} align="left">
                            {
                                      this.props.caseData.selectedArbitrators !== undefined && this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Claimant') !== -1 && this.props.caseData.selectedArbitrators[this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Claimant')].arbitrator
                                      }
                            </TableCell>
                          </TableRow>

                          <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.row}
                              component="th"
                              scope="row"
                            >
                              {this.context.t("respondentArbitrator")}
                            </TableCell>
                            <TableCell className={classes.row} align="left">
                              {
                                      this.props.caseData.selectedArbitrators !== undefined && this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Respondent') !== -1 && this.props.caseData.selectedArbitrators[this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Respondent')].arbitrator
                                      }
                            </TableCell>
                          </TableRow>

                          <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.rowBold}
                              component="th"
                              scope="row"
                            ></TableCell>
                            <TableCell
                              className={classes.row}
                              align="left"
                            ></TableCell>
                          </TableRow>

                          <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.rowBold}
                              component="th"
                              scope="row"
                            >
                              {this.context.t("Claimant's Information")}:
                            </TableCell>
                            <TableCell
                              className={classes.row}
                              align="left"
                            ></TableCell>
                          </TableRow>

                          {this.props.caseData.namesOfA2[0].a4 !==
                            undefined && (
                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("Name")}:
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                                {this.props.caseData.namesOfA2[0].a4}
                              </TableCell>
                            </TableRow>
                          )}

                          {this.props.caseData.namesOfA2[0].a9 && (
                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("Address")}:
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                                {this.props.caseData.namesOfA2[0].a9}
                              </TableCell>
                            </TableRow>
                          )}

                            {this.props.caseData.namesOfA2[0].a11 && (
                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("Address")}:
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                                {this.props.caseData.namesOfA2[0].a11}
                              </TableCell>
                            </TableRow>
                          )}

                          {this.props.caseData.namesOfA2[0].a7 && (
                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("Identity Number")}:
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                                {this.props.caseData.namesOfA2[0].a7}
                              </TableCell>
                            </TableRow>
                          )}

                          {this.props.caseData.namesOfA2[0].a8 &&
                            <TableRow hover style={{ height: 16 }}>
                                <TableCell className={classes.row} component="th" scope="row">
                                    {this.context.t('Identity Number')}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                {this.props.caseData.namesOfA2[0].a8}
                                </TableCell>
                            </TableRow>}

                          {this.props.caseData.namesOfA2[0].a11a && (
                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("E-mail")}:
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                                {this.props.caseData.namesOfA2[0].a11a}
                              </TableCell>
                            </TableRow>
                          )}

                          {this.props.caseData.namesOfA2[0].a11b !==
                            undefined && (
                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("Telephone No")}:
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                                { (this.props.caseData.namesOfA2[0].a11b).replace("852","852 ") }
                              </TableCell>
                            </TableRow>
                          )}

                          <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.rowBold}
                              component="th"
                              scope="row"
                            ></TableCell>
                            <TableCell
                              className={classes.row}
                              align="left"
                            ></TableCell>
                          </TableRow>

                          <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.rowBold}
                              component="th"
                              scope="row"
                            >
                              {this.context.t("Respondent's Information")}
                            </TableCell>
                            <TableCell
                              className={classes.row}
                              align="left"
                            ></TableCell>
                          </TableRow>

                          {this.props.caseData.a12 !== null && (
                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("Name")}:
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                                {this.props.caseData.a12}
                              </TableCell>
                            </TableRow>
                          )}

                          {this.props.caseData.a12a !== null && (
                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("Address")}:
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                                {this.props.caseData.a12a}
                              </TableCell>
                            </TableRow>
                          )}

                          {this.props.caseData.a12x !== null && (
                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("Identity Number")}:
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                                {this.props.caseData.a12x}
                              </TableCell>
                            </TableRow>
                          )}

                          {this.props.caseData.a12b !== null && (
                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("E-mail")}:
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                                {this.props.caseData.a12b}
                              </TableCell>
                            </TableRow>
                          )}

                          {this.props.caseData.a12c !== null && (
                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("Telephone No")}:
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                                {(this.props.caseData.a12c).replace("852","852 ") }
                              </TableCell>
                            </TableRow>
                          )}

                          <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.rowBold}
                              component="th"
                              scope="row"
                            ></TableCell>
                            <TableCell
                              className={classes.row}
                              align="left"
                            ></TableCell>
                          </TableRow>

                          <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.rowBold}
                              component="th"
                              scope="row"
                            >
                              {this.context.t("Payment Status")}:
                            </TableCell>
                            <TableCell
                              className={classes.row}
                              align="left"
                            ></TableCell>
                          </TableRow>

                          {this.props.claimantPayment !== undefined && (
                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("Claimant")}:
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                                {this.context.t("Paid")}
                              </TableCell>
                            </TableRow>
                          )}

                          {this.props.respondentPayment !== undefined && (
                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("Respondent")}:
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                                {this.context.t("Paid")}
                              </TableCell>
                            </TableRow>
                          )}

                          {this.props.claimantPayment == undefined && (
                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("Claimant")}:
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                                --
                              </TableCell>
                            </TableRow>
                          )}

                          {this.props.respondentPayment == undefined && (
                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("Respondent")}:
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                                --
                              </TableCell>
                            </TableRow>
                          )}

                          {/* <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.row}
                              component="th"
                              scope="row"
                            >
                              {this.context.t("Deadline to next step")}:
                            </TableCell>
                            <TableCell className={classes.row} align="left">
                              {this.context.t("6 days")}
                            </TableCell>
                          </TableRow> */}
                        </TableBody>
                      </Table>
                      
                      <SelectedArbitrators/>
                      
                      <DeadlinePanel/>
                      {(this.state.typeOfAccount == "admin" || this.state.typeOfAccount == "arbitrator") && process.env.REACT_APP_MODE === "ts" && <TimerPanel caseData={this.props.caseData}/>}
                      {/* {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <LoginRecords/>}
                      {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <SMSStatus/>}
                      {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <EmailReadStatus/>}
                      {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <SentEmailStatus/>} */}
                    </Grid>

                    {/* {this.state.typeOfAccount !== "admin" && this.state.typeOfAccount !== "arbitrator" && canChooseArbitrator && this.props.caseData.arbitratorStatus !== 'true' && <Grid item spacing={2} md={6} lg={6} sm={6} xs={12}>
                      <ChooseArbitratorForCaseInformation />
                    </Grid>} */}
                    
                  </Grid>
                  
                </div>
              );
            }
          } else {
            if (this.props.caseData.a1 == "sole") {
              if (this.props.caseData.a2 == "vendor") {
                if (this.props.caseData.namesOfVendors !== undefined) {
                  return (
                    <div className={classes.divStyle}>
                      {this.state.typeOfAccount == "arbitrator" &&
                        this.props.caseData.arbitratorStatus == "waiting" && (
                          <ArbitratorAcceptRejectBox />
                        )}
                        {this.props.caseData.arbitratorStatus == "true" && (
                            <ArbitratorAppointed caseData={this.props.caseData} claimantArbitratorName={this.props.claimantArbitratorName} AcceptedArbitratorName={this.props.caseData.AcceptedArbitratorName}  />
                          )}
                          <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                      {this.state.typeOfAccount == "admin" &&
                        this.props.caseData.requireAdminChooseArbitrator ==
                          true && <ChooseArbitratorAdmin />}
                      <Grid container spacing={0}>
                        <Grid item spacing={8} md={6} lg={6} sm={6} xs={12}>
                          <Table className={classes.table}>
                            <TableHead style={{ border: "none" }}>
                              <TableRow style={{ height: 16 }}>
                                <TableCell
                                  className={classes.header}
                                ></TableCell>
                                <TableCell
                                  className={classes.header}
                                  align="left"
                                ></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Case Number")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {this.props.caseData.caseIdName}
                                </TableCell>
                              </TableRow>

                              <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.row}
                              component="th"
                              scope="row"
                            >
                              {this.context.t("Case Date")}:
                            </TableCell>
                            <TableCell className={classes.row} align="left">
                              {new Date(this.props.caseData.timestamp).getFullYear()}-{(new Date(this.props.caseData.timestamp).getMonth()+1).toLocaleString().toString().padStart(2,'0')}-{(new Date(this.props.caseData.timestamp).getDate()).toLocaleString().toString().padStart(2,'0')} {(new Date(this.props.caseData.timestamp).getHours()).toLocaleString().toString().padStart(2,'0')}:{(new Date(this.props.caseData.timestamp).getMinutes()).toLocaleString().toString().padStart(2,'0')}:{(new Date(this.props.caseData.timestamp).getSeconds()).toLocaleString().toString().padStart(2,'0')}
                            </TableCell>
                          </TableRow>

                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("claimantArbitrator")}
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                {
                                   this.props.caseData.selectedArbitrators !== undefined && this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Claimant') !== -1 && this.props.caseData.selectedArbitrators[this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Claimant')].arbitrator
                                   }
                                </TableCell>
                              </TableRow>

                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("respondentArbitrator")}
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {
                                   this.props.caseData.selectedArbitrators !== undefined && this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Respondent') !== -1 && this.props.caseData.selectedArbitrators[this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Respondent')].arbitrator
                                   }
                                </TableCell>
                              </TableRow>

                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.rowBold}
                                  component="th"
                                  scope="row"
                                ></TableCell>
                                <TableCell
                                  className={classes.row}
                                  align="left"
                                ></TableCell>
                              </TableRow>

                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.rowBold}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Claimant's Information")}:
                                </TableCell>
                                <TableCell
                                  className={classes.row}
                                  align="left"
                                ></TableCell>
                              </TableRow>

                              {this.props.caseData.a3 !== undefined && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Name")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {this.props.caseData.a3}
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.caseData.a3a !== undefined && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Address")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {this.props.caseData.a3a}
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.caseData.a7 !== undefined && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Identity Number")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {this.props.caseData.a7}
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.caseData.a3b !== undefined && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("E-mail")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {this.props.caseData.a3b}
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.caseData.a3c !== undefined && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Telephone No")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {(this.props.caseData.a3c).replace("852","852 ") }
                                  </TableCell>
                                </TableRow>
                              )}

                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.rowBold}
                                  component="th"
                                  scope="row"
                                ></TableCell>
                                <TableCell
                                  className={classes.row}
                                  align="left"
                                ></TableCell>
                              </TableRow>

                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.rowBold}
                                  component="th"
                                  scope="row"
                                >
                              {this.context.t("Respondent's Information")}
                                </TableCell>
                                <TableCell
                                  className={classes.row}
                                  align="left"
                                ></TableCell>
                              </TableRow>


                              {this.props.caseData.namesOfVendors.map((e, index) =>(
                                    <React.Fragment key={index}>
                                      <TableRow hover style={{ height: 16 }}>
                                        <TableCell
                                          className={classes.row}
                                          component="th"
                                          scope="row"
                                        >
                                          {this.context.t("Name")}:
                                        </TableCell>
                                        <TableCell
                                          className={classes.row}
                                          align="left"
                                        >
                                          {e.a4}
                                        </TableCell>
                                      </TableRow>

                                      {e.a9 && <TableRow hover style={{ height: 16 }}>
                                        <TableCell
                                          className={classes.row}
                                          component="th"
                                          scope="row"
                                        >
                                          {this.context.t("Address")}:
                                        </TableCell>
                                        <TableCell
                                          className={classes.row}
                                          align="left"
                                        >
                                          {e.a9}
                                        </TableCell>
                                      </TableRow>}

                                      {e.a11 && <TableRow hover style={{ height: 16 }}>
                                        <TableCell
                                          className={classes.row}
                                          component="th"
                                          scope="row"
                                        >
                                          {this.context.t("Address")}:
                                        </TableCell>
                                        <TableCell
                                          className={classes.row}
                                          align="left"
                                        >
                                          {e.a11}
                                        </TableCell>
                                      </TableRow>}

                                      {e.a7 && <TableRow hover style={{ height: 16 }}>
                                        <TableCell
                                          className={classes.row}
                                          component="th"
                                          scope="row"
                                        >
                                          {this.context.t("Identity Number")}:
                                        </TableCell>
                                        <TableCell
                                          className={classes.row}
                                          align="left"
                                        >
                                          {e.a7}
                                        </TableCell>
                                      </TableRow>}

                                      <TableRow hover style={{ height: 16 }}>
                                        <TableCell
                                          className={classes.row}
                                          component="th"
                                          scope="row"
                                        >
                                          {this.context.t("E-mail")}:
                                        </TableCell>
                                        <TableCell
                                          className={classes.row}
                                          align="left"
                                        >
                                          {e.a11a}
                                        </TableCell>
                                      </TableRow>

                                      <TableRow hover style={{ height: 16 }}>
                                        <TableCell
                                          className={classes.row}
                                          component="th"
                                          scope="row"
                                        >
                                          {this.context.t("Telephone No")}:
                                        </TableCell>
                                        <TableCell
                                          className={classes.row}
                                          align="left"
                                        >
                                          {(e.a11b).replace("852","852 ") }
                                        </TableCell>
                                      </TableRow>
                                    {/* </div> */}
                                    </React.Fragment>
                                  )
                                )
                              }

                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.rowBold}
                                  component="th"
                                  scope="row"
                                ></TableCell>
                                <TableCell
                                  className={classes.row}
                                  align="left"
                                ></TableCell>
                              </TableRow>

                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.rowBold}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Payment Status")}:
                                </TableCell>
                                <TableCell
                                  className={classes.row}
                                  align="left"
                                ></TableCell>
                              </TableRow>

                              {this.props.claimantPayment !== undefined && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Claimant")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {this.context.t("Paid")}
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.respondentPayment !== undefined && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Respondent")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {this.context.t("Paid")}
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.claimantPayment == undefined && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Claimant")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    --
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.respondentPayment == undefined && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Respondent")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    --
                                  </TableCell>
                                </TableRow>
                              )}

                              {/* <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Deadline to next step")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {this.context.t("6 days")}
                                </TableCell>
                              </TableRow> */}
                            </TableBody>
                          </Table>
                          <SelectedArbitrators/>
                          <DeadlinePanel/>
                          {(this.state.typeOfAccount == "admin" || this.state.typeOfAccount == "arbitrator") && process.env.REACT_APP_MODE === "ts" && <TimerPanel caseData={this.props.caseData}/>}
                          {/* {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <LoginRecords/>}
                          {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <SMSStatus/>}
                          {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <EmailReadStatus/>}
                          {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <SentEmailStatus/>} */}
                        </Grid>
                        {/* {this.state.typeOfAccount !== "admin" && this.state.typeOfAccount !== "arbitrator" && canChooseArbitrator && this.props.caseData.arbitratorStatus !== 'true' && <Grid item spacing={2} md={6} lg={6} sm={6} xs={12}>
                          <ChooseArbitratorForCaseInformation />
                        </Grid>} */}
                      </Grid>
                    </div>
                  );
                }
              } 
              else if (this.props.caseData.a2 == "purchaser") {
                if (this.props.caseData.namesOfPurchasers !== undefined) {
                  return (
                    <div className={classes.divStyle}>
                      {this.state.typeOfAccount == "arbitrator" &&
                        this.props.caseData.arbitratorStatus == "waiting" && (
                          <ArbitratorAcceptRejectBox />
                        )}
                        {this.props.caseData.arbitratorStatus == "true" && (
                            <ArbitratorAppointed caseData={this.props.caseData} claimantArbitratorName={this.props.claimantArbitratorName} AcceptedArbitratorName={this.props.caseData.AcceptedArbitratorName}  />
                          )}
                          <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                      {this.state.typeOfAccount == "admin" &&
                        this.props.caseData.requireAdminChooseArbitrator ==
                          true && <ChooseArbitratorAdmin />}
                      <Grid container spacing={8}>
                        <Grid item spacing={8} md={6} lg={6} sm={6} xs={12}>
                          <Table className={classes.table}>
                            <TableHead style={{ border: "none" }}>
                              <TableRow style={{ height: 16 }}>
                                <TableCell
                                  className={classes.header}
                                ></TableCell>
                                <TableCell
                                  className={classes.header}
                                  align="left"
                                ></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Case Number")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {this.props.caseData.caseIdName}
                                </TableCell>
                              </TableRow>

                              <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.row}
                              component="th"
                              scope="row"
                            >
                              {this.context.t("Case Date")}:
                            </TableCell>
                            <TableCell className={classes.row} align="left">
                              {new Date(this.props.caseData.timestamp).getFullYear()}-{(new Date(this.props.caseData.timestamp).getMonth()+1).toLocaleString().toString().padStart(2,'0')}-{(new Date(this.props.caseData.timestamp).getDate()).toLocaleString().toString().padStart(2,'0')} {(new Date(this.props.caseData.timestamp).getHours()).toLocaleString().toString().padStart(2,'0')}:{(new Date(this.props.caseData.timestamp).getMinutes()).toLocaleString().toString().padStart(2,'0')}:{(new Date(this.props.caseData.timestamp).getSeconds()).toLocaleString().toString().padStart(2,'0')}
                            </TableCell>
                          </TableRow>

                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("claimantArbitrator")}
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                {
                                   this.props.caseData.selectedArbitrators !== undefined && this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Claimant') !== -1 && this.props.caseData.selectedArbitrators[this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Claimant')].arbitrator
                                   }
                                </TableCell>
                              </TableRow>

                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("respondentArbitrator")}
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {
                                   this.props.caseData.selectedArbitrators !== undefined && this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Respondent') !== -1 && this.props.caseData.selectedArbitrators[this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Respondent')].arbitrator
                                   }
                                </TableCell>
                              </TableRow>

                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.rowBold}
                                  component="th"
                                  scope="row"
                                ></TableCell>
                                <TableCell
                                  className={classes.row}
                                  align="left"
                                ></TableCell>
                              </TableRow>

                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.rowBold}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Claimant's Information")}:
                                </TableCell>
                                <TableCell
                                  className={classes.row}
                                  align="left"
                                ></TableCell>
                              </TableRow>

                              {this.props.caseData.a3 !== undefined && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Name")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {this.props.caseData.a3}
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.caseData.a3a !== undefined && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Address")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {this.props.caseData.a3a}
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.caseData.a7 !== undefined && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Identity Number")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {this.props.caseData.a7}
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.caseData.a3b !== undefined && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("E-mail")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {this.props.caseData.a3b}
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.caseData.a3c !== undefined && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Telephone No")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {(this.props.caseData.a3c).replace("852","852 ") }
                                  </TableCell>
                                </TableRow>
                              )}

                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.rowBold}
                                  component="th"
                                  scope="row"
                                ></TableCell>
                                <TableCell
                                  className={classes.row}
                                  align="left"
                                ></TableCell>
                              </TableRow>

                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.rowBold}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Respondent's Information")}
                                </TableCell>
                                <TableCell
                                  className={classes.row}
                                  align="left"
                                ></TableCell>
                              </TableRow>

                              {this.props.caseData.namesOfPurchasers[0].a12a !==
                                null && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Name")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {
                                      this.props.caseData.namesOfPurchasers[0]
                                        .a12a
                                    }
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.caseData.namesOfPurchasers[0].a12f !==
                                null && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Address")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {
                                      this.props.caseData.namesOfPurchasers[0]
                                        .a12f
                                    }
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.caseData.namesOfPurchasers[0].a12d !==
                                null && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Identity Number")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {
                                      this.props.caseData.namesOfPurchasers[0]
                                        .a12d
                                    }
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.caseData.namesOfPurchasers[0].a12e !==
                                null && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Identity Number")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {
                                      this.props.caseData.namesOfPurchasers[0]
                                        .a12e
                                    }
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.caseData.namesOfPurchasers[0].a12h !==
                                null && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Address")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    { this.props.caseData.namesOfPurchasers[0].a12h }
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.caseData.namesOfPurchasers[0].a12i !==
                                null && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("E-mail")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {this.props.caseData.namesOfPurchasers[0].a12i}
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.caseData.namesOfPurchasers[0].a12j !==
                                null && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Telephone No")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {
                                      (this.props.caseData.namesOfPurchasers[0]
                                        .a12j).replace("852","852 ") 
                                    }
                                  </TableCell>
                                </TableRow>
                              )}

                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.rowBold}
                                  component="th"
                                  scope="row"
                                ></TableCell>
                                <TableCell
                                  className={classes.row}
                                  align="left"
                                ></TableCell>
                              </TableRow>

                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.rowBold}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Payment Status")}:
                                </TableCell>
                                <TableCell
                                  className={classes.row}
                                  align="left"
                                ></TableCell>
                              </TableRow>

                              {this.props.claimantPayment !== undefined && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Claimant")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {this.context.t("Paid")}
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.respondentPayment !== undefined && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Respondent")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    {this.context.t("Paid")}
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.claimantPayment == undefined && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Claimant")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    --
                                  </TableCell>
                                </TableRow>
                              )}

                              {this.props.respondentPayment == undefined && (
                                <TableRow hover style={{ height: 16 }}>
                                  <TableCell
                                    className={classes.row}
                                    component="th"
                                    scope="row"
                                  >
                                    {this.context.t("Respondent")}:
                                  </TableCell>
                                  <TableCell
                                    className={classes.row}
                                    align="left"
                                  >
                                    --
                                  </TableCell>
                                </TableRow>
                              )}

                              {/* <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Deadline to next step")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {this.context.t("6 days")}
                                </TableCell>
                              </TableRow> */}
                            </TableBody>
                          </Table>
                          <SelectedArbitrators/>
                          <DeadlinePanel/>
                          {(this.state.typeOfAccount == "admin" || this.state.typeOfAccount == "arbitrator") && process.env.REACT_APP_MODE === "ts" && <TimerPanel caseData={this.props.caseData}/>}
                          {/* {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <LoginRecords/>}
                          {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <SMSStatus/>}
                          {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <EmailReadStatus/>}
                          {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <SentEmailStatus/>} */}
                        </Grid>

                        {/* {this.state.typeOfAccount !== "admin" && this.state.typeOfAccount !== "arbitrator" && canChooseArbitrator && this.props.caseData.arbitratorStatus !== 'true' && <Grid item spacing={2} md={6} lg={6} sm={6} xs={12}>
                          <ChooseArbitratorForCaseInformation />
                        </Grid>} */}
                      </Grid>
                    </div>
                  );
                }
              }
            } 
            else if (this.props.caseData.a1 == "seperate") {
              if (this.props.caseData.namesOfA2 !== undefined) {
                return (
                  <div className={classes.divStyle}>
                    {this.state.typeOfAccount == "arbitrator" &&
                      this.props.caseData.arbitratorStatus == "waiting" && (
                        <ArbitratorAcceptRejectBox />
                      )}
                      {this.props.caseData.arbitratorStatus == "true" && (
                          <ArbitratorAppointed caseData={this.props.caseData} claimantArbitratorName={this.props.claimantArbitratorName} AcceptedArbitratorName={this.props.caseData.AcceptedArbitratorName}  />
                        )}
                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                    {this.state.typeOfAccount == "admin" &&
                      this.props.caseData.requireAdminChooseArbitrator ==
                        true && <ChooseArbitratorAdmin />}
                    <Grid container spacing={0}>
                      <Grid item spacing={8} md={6} lg={6} sm={6} xs={12}>
                        <Table className={classes.table}>
                          <TableHead style={{ border: "none" }}>
                            <TableRow style={{ height: 16 }}>
                              <TableCell className={classes.header}></TableCell>
                              <TableCell
                                className={classes.header}
                                align="left"
                              ></TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("Case Number")}:
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                                {this.props.caseData.caseIdName}
                              </TableCell>
                            </TableRow>

                            <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.row}
                              component="th"
                              scope="row"
                            >
                              {this.context.t("Case Date")}:
                            </TableCell>
                            <TableCell className={classes.row} align="left">
                              {new Date(this.props.caseData.timestamp).getFullYear()}-{(new Date(this.props.caseData.timestamp).getMonth()+1).toLocaleString().toString().padStart(2,'0')}-{(new Date(this.props.caseData.timestamp).getDate()).toLocaleString().toString().padStart(2,'0')} {(new Date(this.props.caseData.timestamp).getHours()).toLocaleString().toString().padStart(2,'0')}:{(new Date(this.props.caseData.timestamp).getMinutes()).toLocaleString().toString().padStart(2,'0')}:{(new Date(this.props.caseData.timestamp).getSeconds()).toLocaleString().toString().padStart(2,'0')}
                            </TableCell>
                          </TableRow>

                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("claimantArbitrator")}
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                              {
                                   this.props.caseData.selectedArbitrators !== undefined && this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Claimant') !== -1 && this.props.caseData.selectedArbitrators[this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Claimant')].arbitrator
                              }
                              </TableCell>
                            </TableRow>

                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("respondentArbitrator")}
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                                {
                                   this.props.caseData.selectedArbitrators !== undefined && this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Respondent') !== -1 && this.props.caseData.selectedArbitrators[this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Respondent')].arbitrator
                                   }
                              </TableCell>
                            </TableRow>

                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.rowBold}
                                component="th"
                                scope="row"
                              ></TableCell>
                              <TableCell
                                className={classes.row}
                                align="left"
                              ></TableCell>
                            </TableRow>

                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.rowBold}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("Claimant's Information")}:
                              </TableCell>
                              <TableCell
                                className={classes.row}
                                align="left"
                              ></TableCell>
                            </TableRow>

                            {this.props.caseData.a3 !== undefined && (
                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Name")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {this.props.caseData.a3}
                                </TableCell>
                              </TableRow>
                            )}

                            {this.props.caseData.a3a !== undefined && (
                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Address")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {this.props.caseData.a3a}
                                </TableCell>
                              </TableRow>
                            )}

                            {this.props.caseData.a7 !== undefined && (
                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Identity Number")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {this.props.caseData.a7}
                                </TableCell>
                              </TableRow>
                            )}

                            {this.props.caseData.a3b !== undefined && (
                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("E-mail")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {this.props.caseData.a3b}
                                </TableCell>
                              </TableRow>
                            )}

                            {this.props.caseData.a3c !== undefined && (
                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Telephone No")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {(this.props.caseData.a3c).replace("852","852 ") }
                                </TableCell>
                              </TableRow>
                            )}

                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.rowBold}
                                component="th"
                                scope="row"
                              ></TableCell>
                              <TableCell
                                className={classes.row}
                                align="left"
                              ></TableCell>
                            </TableRow>

                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.rowBold}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("Respondent's Information")}
                              </TableCell>
                              <TableCell
                                className={classes.row}
                                align="left"
                              ></TableCell>
                            </TableRow>

                            {this.props.caseData.namesOfA2[0].a4 !== null && (
                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Name")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {this.props.caseData.namesOfA2[0].a4}
                                </TableCell>
                              </TableRow>
                            )}

                            {this.props.caseData.namesOfA2[0].a11 !== null && (
                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Address")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {this.props.caseData.namesOfA2[0].a11}
                                </TableCell>
                              </TableRow>
                            )}

                            {this.props.caseData.namesOfA2[0].a7 !== null && (
                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Identity Number")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {this.props.caseData.namesOfA2[0].a7}
                                </TableCell>
                              </TableRow>
                            )}

                            {this.props.caseData.namesOfA2[0].a8 !== null && (
                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Identity Number")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {this.props.caseData.namesOfA2[0].a8}
                                </TableCell>
                              </TableRow>
                            )}

                            {this.props.caseData.namesOfA2[0].a9 !== null && (
                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Address")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {this.props.caseData.namesOfA2[0].a9}
                                </TableCell>
                              </TableRow>
                            )}

                            {this.props.caseData.namesOfA2[0].a11a !== null && (
                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("E-mail")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {this.props.caseData.namesOfA2[0].a11a}
                                </TableCell>
                              </TableRow>
                            )}

                            {this.props.caseData.namesOfA2[0].a11b !== null && (
                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Telephone No")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {(this.props.caseData.namesOfA2[0].a11b).replace("852","852 ") }
                                </TableCell>
                              </TableRow>
                            )}

                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.rowBold}
                                component="th"
                                scope="row"
                              ></TableCell>
                              <TableCell
                                className={classes.row}
                                align="left"
                              ></TableCell>
                            </TableRow>

                            <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.rowBold}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("Payment Status")}:
                              </TableCell>
                              <TableCell
                                className={classes.row}
                                align="left"
                              ></TableCell>
                            </TableRow>

                            {this.props.claimantPayment !== undefined && (
                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Claimant")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {this.context.t("Paid")}
                                </TableCell>
                              </TableRow>
                            )}

                            {this.props.respondentPayment !== undefined && (
                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Respondent")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  {this.context.t("Paid")}
                                </TableCell>
                              </TableRow>
                            )}

                            {this.props.claimantPayment == undefined && (
                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Claimant")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  --
                                </TableCell>
                              </TableRow>
                            )}

                            {this.props.respondentPayment == undefined && (
                              <TableRow hover style={{ height: 16 }}>
                                <TableCell
                                  className={classes.row}
                                  component="th"
                                  scope="row"
                                >
                                  {this.context.t("Respondent")}:
                                </TableCell>
                                <TableCell className={classes.row} align="left">
                                  --
                                </TableCell>
                              </TableRow>
                            )}

                            {/* <TableRow hover style={{ height: 16 }}>
                              <TableCell
                                className={classes.row}
                                component="th"
                                scope="row"
                              >
                                {this.context.t("Deadline to next step")}:
                              </TableCell>
                              <TableCell className={classes.row} align="left">
                                {this.context.t("6 days")}
                              </TableCell>
                            </TableRow> */}
                          </TableBody>
                        </Table>
                        <SelectedArbitrators/>
                        <DeadlinePanel/>
                        {(this.state.typeOfAccount == "admin" || this.state.typeOfAccount == "arbitrator") && process.env.REACT_APP_MODE === "ts" && <TimerPanel caseData={this.props.caseData}/>}
                        {/* {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <LoginRecords/>}
                        {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <SMSStatus/>}
                        {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <EmailReadStatus/>}
                        {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <SentEmailStatus/>} */}
                      </Grid>

                      {/* {this.state.typeOfAccount !== "admin" && this.state.typeOfAccount !== "arbitrator" && canChooseArbitrator && this.props.caseData.arbitratorStatus !== 'true' && <Grid item spacing={2} md={6} lg={6} sm={6} xs={12}>
                        <ChooseArbitratorForCaseInformation />
                      </Grid>} */}
                    </Grid>
                  </div>
                );
              }
            }
          }
        } else if (this.props.caseData.agreement_type == "MoneyLent") {
          return (
            <div className={classes.divStyle}>
              {this.state.typeOfAccount == "arbitrator" &&
                this.props.caseData.arbitratorStatus == "waiting" && (
                  <ArbitratorAcceptRejectBox />
                )}
                {this.props.caseData.arbitratorStatus == "true" && (
                    <ArbitratorAppointed caseData={this.props.caseData} claimantArbitratorName={this.props.claimantArbitratorName} AcceptedArbitratorName={this.props.caseData.AcceptedArbitratorName}  />
                  )}
              {this.state.typeOfAccount == "admin" &&
                this.props.caseData.requireAdminChooseArbitrator == true && (
                  <ChooseArbitratorAdmin />
                )}
                <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
              <Grid container spacing={0}>
                <Grid item spacing={8} md={6} lg={6} sm={6} xs={12}>
                  <Table className={classes.table}>
                    <TableHead style={{ border: "none" }}>
                      <TableRow style={{ height: 16 }}>
                        <TableCell className={classes.header}></TableCell>
                        <TableCell
                          className={classes.header}
                          align="left"
                        ></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.row}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Case Number")}:
                        </TableCell>
                        <TableCell className={classes.row} align="left">
                          {this.props.caseData.caseIdName}
                        </TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.row}
                              component="th"
                              scope="row"
                            >
                              {this.context.t("Case Date")}:
                            </TableCell>
                            <TableCell className={classes.row} align="left">
                              {new Date(this.props.caseData.timestamp).getFullYear()}-{(new Date(this.props.caseData.timestamp).getMonth()+1).toLocaleString().toString().padStart(2,'0')}-{(new Date(this.props.caseData.timestamp).getDate()).toLocaleString().toString().padStart(2,'0')} {(new Date(this.props.caseData.timestamp).getHours()).toLocaleString().toString().padStart(2,'0')}:{(new Date(this.props.caseData.timestamp).getMinutes()).toLocaleString().toString().padStart(2,'0')}:{(new Date(this.props.caseData.timestamp).getSeconds()).toLocaleString().toString().padStart(2,'0')}
                            </TableCell>
                          </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.row}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("claimantArbitrator")}
                        </TableCell>
                        <TableCell className={classes.row} align="left">
                        {
                                   this.props.caseData.selectedArbitrators !== undefined && this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Claimant') !== -1 && this.props.caseData.selectedArbitrators[this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Claimant')].arbitrator
                                   }
                        </TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.row}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("respondentArbitrator")}
                        </TableCell>
                        <TableCell className={classes.row} align="left">
                          {
                                   this.props.caseData.selectedArbitrators !== undefined && this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Respondent') !== -1 && this.props.caseData.selectedArbitrators[this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Respondent')].arbitrator
                                   }
                        </TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        ></TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Claimant's Information")}:
                        </TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      {this.props.claimant_name !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Name")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.claimant_name}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.claimant_registered_address !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Address")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.claimant_registered_address}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.claimant_hkid !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Identity Number")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.claimant_hkid}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.claimant_passport !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Identity Number")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.claimant_passport}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.claimant_address !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Address")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.claimant_address}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.claimant_email_address !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("E-mail")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.claimant_email_address}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.claimant_telephone !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Telephone No")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {(this.props.claimant_telephone).replace("852","852 ") }
                          </TableCell>
                        </TableRow>
                      )}

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        ></TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Respondent's Information")}
                        </TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      {this.props.respondent_name !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Name")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.respondent_name}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.respondent_registered_address !==
                        undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Address")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.respondent_registered_address}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.respondent_hkid !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Identity Number")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.respondent_hkid}
                          </TableCell>
                        </TableRow>
                      )}

                    {this.props.respondent_passport !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Identity Number")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.respondent_passport}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.respondent_address !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Address")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.respondent_address}
                          </TableCell>
                        </TableRow>
                      )}

                      {/* {this.props.respondent_address !== undefined &&
                                    <TableRow hover style={{ height: 16 }}>
                                        <TableCell className={classes.row} component="th" scope="row">
                                            {this.context.t("Address")}:
                                        </TableCell>
                                        <TableCell className={classes.row} align="left">
                                        {this.props.respondent_address}
                                        </TableCell>
                                    </TableRow>} */}

                      {this.props.respondent_email_address !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("E-mail")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.respondent_email_address}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.respondent_telephone !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Telephone No")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {(this.props.respondent_telephone).replace("852","852 ") }
                          </TableCell>
                        </TableRow>
                      )}

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        ></TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Payment Status")}:
                        </TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      {this.props.claimantPayment !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Claimant")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.context.t("Paid")}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.respondentPayment !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Respondent")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.context.t("Paid")}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.claimantPayment == undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Claimant")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            --
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.respondentPayment == undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Respondent")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            --
                          </TableCell>
                        </TableRow>
                      )}

                      {/* <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.row}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Deadline to next step")}:
                        </TableCell>
                        <TableCell className={classes.row} align="left">
                          {this.context.t("6 days")}
                        </TableCell>
                      </TableRow> */}
                    </TableBody>
                  </Table>
                  <SelectedArbitrators/>
                  <DeadlinePanel/>
                  {(this.state.typeOfAccount == "admin" || this.state.typeOfAccount == "arbitrator") && process.env.REACT_APP_MODE === "ts" && <TimerPanel caseData={this.props.caseData}/>}
                  {/* {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <LoginRecords/>}
                  {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <SMSStatus/>}
                  {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <EmailReadStatus/>}
                  {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <SentEmailStatus/>} */}
                </Grid>

                {/* {this.state.typeOfAccount !== "admin" && this.state.typeOfAccount !== "arbitrator" && canChooseArbitrator && this.props.caseData.arbitratorStatus !== 'true' && <Grid item spacing={2} md={6} lg={6} sm={6} xs={12}>
                  <ChooseArbitratorForCaseInformation />
                </Grid>} */}
              </Grid>
            </div>
          );
        } else if (this.props.caseData.agreement_type == "creditcard") {
          return (
            <div className={classes.divStyle}>
              {this.state.typeOfAccount == "arbitrator" &&
                this.props.caseData.arbitratorStatus == "waiting" && (
                  <ArbitratorAcceptRejectBox />
                )}
                {this.props.caseData.arbitratorStatus == "true" && (
                    <ArbitratorAppointed caseData={this.props.caseData} claimantArbitratorName={this.props.claimantArbitratorName} AcceptedArbitratorName={this.props.caseData.AcceptedArbitratorName}  />
                  )}
              {this.state.typeOfAccount == "admin" &&
                this.props.caseData.requireAdminChooseArbitrator == true && (
                  <ChooseArbitratorAdmin />
                )}
                <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
              <Grid container spacing={0}>
                <Grid item spacing={8} md={6} lg={6} sm={6} xs={12}>
                  <Table className={classes.table}>
                    <TableHead style={{ border: "none" }}>
                      <TableRow style={{ height: 16 }}>
                        <TableCell className={classes.header}></TableCell>
                        <TableCell
                          className={classes.header}
                          align="left"
                        ></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.row}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Case Number")}:
                        </TableCell>
                        <TableCell className={classes.row} align="left">
                          {this.props.caseData.caseIdName}
                        </TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.row}
                              component="th"
                              scope="row"
                            >
                              {this.context.t("Case Date")}:
                            </TableCell>
                            <TableCell className={classes.row} align="left">
                              {new Date(this.props.caseData.timestamp).getFullYear()}-{(new Date(this.props.caseData.timestamp).getMonth()+1).toLocaleString().toString().padStart(2,'0')}-{(new Date(this.props.caseData.timestamp).getDate()).toLocaleString().toString().padStart(2,'0')} {(new Date(this.props.caseData.timestamp).getHours()).toLocaleString().toString().padStart(2,'0')}:{(new Date(this.props.caseData.timestamp).getMinutes()).toLocaleString().toString().padStart(2,'0')}:{(new Date(this.props.caseData.timestamp).getSeconds()).toLocaleString().toString().padStart(2,'0')}
                            </TableCell>
                          </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.row}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("claimantArbitrator")}
                        </TableCell>
                        <TableCell className={classes.row} align="left">
                        {
                                   this.props.caseData.selectedArbitrators !== undefined && this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Claimant') !== -1 && this.props.caseData.selectedArbitrators[this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Claimant')].arbitrator
                                   }
                        </TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.row}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("respondentArbitrator")}
                        </TableCell>
                        <TableCell className={classes.row} align="left">
                          {
                                   this.props.caseData.selectedArbitrators !== undefined && this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Respondent') !== -1 && this.props.caseData.selectedArbitrators[this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Respondent')].arbitrator
                                   }
                        </TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        ></TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Claimant's Information")}:
                        </TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      {this.props.caseData.a1 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Name")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a1}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a8 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Address")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a8}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a8b !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("E-mail")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a8b}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a8c !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Telephone No")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {(this.props.caseData.a8c).replace("852","852 ") }
                          </TableCell>
                        </TableRow>
                      )}

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        ></TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Respondent's Information")}
                        </TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      {this.props.caseData.a9 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Name")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a9}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a16 !==
                        undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Address")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a16}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a11 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Identity Number")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a11}
                          </TableCell>
                        </TableRow>
                      )}

                    {this.props.caseData.a13 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Identity Number")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a13}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a14 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Address")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a14}
                          </TableCell>
                        </TableRow>
                      )}

                      {/* {this.props.respondent_address !== undefined &&
                                    <TableRow hover style={{ height: 16 }}>
                                        <TableCell className={classes.row} component="th" scope="row">
                                            {this.context.t("Address")}:
                                        </TableCell>
                                        <TableCell className={classes.row} align="left">
                                        {this.props.respondent_address}
                                        </TableCell>
                                    </TableRow>} */}

                      {this.props.caseData.a16a !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("E-mail")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a16a}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a16b !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Telephone No")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {(this.props.caseData.a16b).replace("852","852 ") }
                          </TableCell>
                        </TableRow>
                      )}

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        ></TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Payment Status")}:
                        </TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      {this.props.claimantPayment !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Claimant")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.context.t("Paid")}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.respondentPayment !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Respondent")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.context.t("Paid")}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.claimantPayment == undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Claimant")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            --
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.respondentPayment == undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Respondent")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            --
                          </TableCell>
                        </TableRow>
                      )}

                      {/* <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.row}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Deadline to next step")}:
                        </TableCell>
                        <TableCell className={classes.row} align="left">
                          {this.context.t("6 days")}
                        </TableCell>
                      </TableRow> */}
                    </TableBody>
                  </Table>
                  <SelectedArbitrators/>
                  <DeadlinePanel/>
                  {(this.state.typeOfAccount == "admin" || this.state.typeOfAccount == "arbitrator") && process.env.REACT_APP_MODE === "ts" && <TimerPanel caseData={this.props.caseData}/>}
                  {/* {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <LoginRecords/>}
                  {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <SMSStatus/>}
                  {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <EmailReadStatus/>}
                  {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <SentEmailStatus/>} */}
                </Grid>

                {/* {this.state.typeOfAccount !== "admin" && this.state.typeOfAccount !== "arbitrator" && canChooseArbitrator && this.props.caseData.arbitratorStatus !== 'true' && <Grid item spacing={2} md={6} lg={6} sm={6} xs={12}>
                  <ChooseArbitratorForCaseInformation />
                </Grid>} */}
              </Grid>
            </div>
          );
        } else if (this.props.caseData.agreement_type == "other_dispute") { 
          return (
            <div className={classes.divStyle}>
              {this.state.typeOfAccount == "arbitrator" &&
                this.props.caseData.arbitratorStatus == "waiting" && (
                  <ArbitratorAcceptRejectBox />
                )}
                {this.props.caseData.arbitratorStatus == "true" && (
                    <ArbitratorAppointed caseData={this.props.caseData} claimantArbitratorName={this.props.claimantArbitratorName} AcceptedArbitratorName={this.props.caseData.AcceptedArbitratorName}  />
                  )}
              {this.state.typeOfAccount == "admin" &&
                this.props.caseData.requireAdminChooseArbitrator == true && (
                  <ChooseArbitratorAdmin />
                )}
                <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
              {/* {(this.state.typeOfAccount == 'admin') && (this.props.caseData.isAccepted == false) && <AdminAcceptRejectBox/>} */}
              <Grid container spacing={0}>
                <Grid item spacing={8} md={6} lg={6} sm={6} xs={12}>
                  <Table className={classes.table}>
                    <TableHead style={{ border: "none" }}>
                      <TableRow style={{ height: 16 }}>
                        <TableCell className={classes.header}></TableCell>
                        <TableCell
                          className={classes.header}
                          align="left"
                        ></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.row}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Case Number")}:
                        </TableCell>
                        <TableCell className={classes.row} align="left">
                          {this.props.caseData.caseIdName}
                        </TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.row}
                              component="th"
                              scope="row"
                            >
                              {this.context.t("Case Date")}:
                            </TableCell>
                            <TableCell className={classes.row} align="left">
                              {new Date(this.props.caseData.timestamp).getFullYear()}-{(new Date(this.props.caseData.timestamp).getMonth()+1).toLocaleString().toString().padStart(2,'0')}-{(new Date(this.props.caseData.timestamp).getDate()).toLocaleString().toString().padStart(2,'0')} {(new Date(this.props.caseData.timestamp).getHours()).toLocaleString().toString().padStart(2,'0')}:{(new Date(this.props.caseData.timestamp).getMinutes()).toLocaleString().toString().padStart(2,'0')}:{(new Date(this.props.caseData.timestamp).getSeconds()).toLocaleString().toString().padStart(2,'0')}
                            </TableCell>
                          </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.row}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("claimantArbitrator")}
                        </TableCell>
                        <TableCell className={classes.row} align="left">
                        {
                                   this.props.caseData.selectedArbitrators !== undefined && this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Claimant') !== -1 && this.props.caseData.selectedArbitrators[this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Claimant')].arbitrator
                                   }
                        </TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.row}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("respondentArbitrator")}
                        </TableCell>
                        <TableCell className={classes.row} align="left">
                          {this.props.caseData.respondentArbitratorName}
                        </TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        ></TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Claimant's Information")}:
                        </TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      {this.props.caseData.a1 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Name")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a1}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a8 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Address")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a8}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a4 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Identity Number")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a4}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a6 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Address")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a6}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a8b !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("E-mail")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a8b}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a8c !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Telephone No")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {(this.props.caseData.a8c).replace("852","852 ") }
                          </TableCell>
                        </TableRow>
                      )}

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        ></TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Respondent's Information")}
                        </TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      {this.props.caseData.a9 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Name")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a9}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a16 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Address")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a16}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a12 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Identity Number")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a12}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a14 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Address")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a14}
                          </TableCell>
                        </TableRow>
                      )}

                      {/* {this.props.respondent_address !== undefined &&
                                    <TableRow hover style={{ height: 16 }}>
                                        <TableCell className={classes.row} component="th" scope="row">
                                            {this.context.t("Address")}:
                                        </TableCell>
                                        <TableCell className={classes.row} align="left">
                                        {this.props.respondent_address}
                                        </TableCell>
                                    </TableRow>} */}

                      {this.props.caseData.a16a !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("E-mail")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a16a}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a16b !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Telephone No")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {(this.props.caseData.a16b).replace("852","852 ") }
                          </TableCell>
                        </TableRow>
                      )}

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        ></TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Payment Status")}:
                        </TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      {this.props.caseData.claimantPayment !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Claimant")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.context.t("Paid")}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.respondentPayment !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Respondent")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.context.t("Paid")}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.claimantPayment == undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Claimant")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            --
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.respondentPayment == undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Respondent")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            --
                          </TableCell>
                        </TableRow>
                      )}

                      {/* <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.row}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Deadline to next step")}:
                        </TableCell>
                        <TableCell className={classes.row} align="left">
                          {this.context.t("6 days")}
                        </TableCell>
                      </TableRow> */}
                    </TableBody>
                  </Table>
                  <SelectedArbitrators/>
                  <DeadlinePanel/>
                  {(this.state.typeOfAccount == "admin" || this.state.typeOfAccount == "arbitrator") && process.env.REACT_APP_MODE === "ts" && <TimerPanel caseData={this.props.caseData}/>}
                  {/* {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <LoginRecords/>}
                  {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <SMSStatus/>}
                  {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <EmailReadStatus/>}
                  {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <SentEmailStatus/>} */}
                </Grid>

                {/* {this.state.typeOfAccount !== "admin" && this.state.typeOfAccount !== "arbitrator" && canChooseArbitrator && this.props.caseData.arbitratorStatus !== 'true' && <Grid item spacing={2} md={6} lg={6} sm={6} xs={12}>
                  <ChooseArbitratorForCaseInformation />
                </Grid>} */}
              </Grid>
            </div>
          );
        } else if (this.props.caseData.agreement_type == 'SalesOfGoods' || this.props.caseData.agreement_type == 'serviceDispute' || this.props.caseData.agreement_type == 'insuranceDispute') {
          return (
            <div className={classes.divStyle}>
              <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
              {this.state.typeOfAccount == "arbitrator" &&
                this.props.caseData.arbitratorStatus == "waiting" && (
                  <ArbitratorAcceptRejectBox />
                )}
                {this.props.caseData.arbitratorStatus == "true" && (
                    <ArbitratorAppointed caseData={this.props.caseData} claimantArbitratorName={this.props.claimantArbitratorName} AcceptedArbitratorName={this.props.caseData.AcceptedArbitratorName}  />
                  )}
              {this.state.typeOfAccount == "admin" &&
                this.props.caseData.requireAdminChooseArbitrator == true && (
                  <ChooseArbitratorAdmin />
                )}
              <Grid container spacing={0}>
                <Grid item spacing={8} md={6} lg={6} sm={6} xs={12}>
                  <Table className={classes.table}>
                    <TableHead style={{ border: "none" }}>
                      <TableRow style={{ height: 16 }}>
                        <TableCell className={classes.header}></TableCell>
                        <TableCell
                          className={classes.header}
                          align="left"
                        ></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.row}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Case Number")}:
                        </TableCell>
                        <TableCell className={classes.row} align="left">
                          {this.props.caseData.caseIdName}
                        </TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                            <TableCell
                              className={classes.row}
                              component="th"
                              scope="row"
                            >
                              {this.context.t("Case Date")}:
                            </TableCell>
                            <TableCell className={classes.row} align="left">
                              {new Date(this.props.caseData.timestamp).getFullYear()}-{(new Date(this.props.caseData.timestamp).getMonth()+1).toLocaleString().toString().padStart(2,'0')}-{(new Date(this.props.caseData.timestamp).getDate()).toLocaleString().toString().padStart(2,'0')} {(new Date(this.props.caseData.timestamp).getHours()).toLocaleString().toString().padStart(2,'0')}:{(new Date(this.props.caseData.timestamp).getMinutes()).toLocaleString().toString().padStart(2,'0')}:{(new Date(this.props.caseData.timestamp).getSeconds()).toLocaleString().toString().padStart(2,'0')}
                            </TableCell>
                          </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.row}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("claimantArbitrator")}
                        </TableCell>
                        <TableCell className={classes.row} align="left">
                        {
                                   this.props.caseData.selectedArbitrators !== undefined && this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Claimant') !== -1 && this.props.caseData.selectedArbitrators[this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Claimant')].arbitrator
                                   }
                        </TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.row}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("respondentArbitrator")}
                        </TableCell>
                        <TableCell className={classes.row} align="left">
                          {
                                   this.props.caseData.selectedArbitrators !== undefined && this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Respondent') !== -1 && this.props.caseData.selectedArbitrators[this.props.caseData.selectedArbitrators.findIndex((e) => e.userType == 'Respondent')].arbitrator
                                   }
                        </TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        ></TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Claimant's Information")}:
                        </TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      {this.props.caseData.a1 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Name")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a1}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a8 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Address")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a8}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a4 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Identity Number")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a4}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a6 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Address")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a6}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a8b !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("E-mail")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a8b}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a8c !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Telephone No")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {(this.props.caseData.a8c).replace("852","852 ") }
                          </TableCell>
                        </TableRow>
                      )}

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        ></TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Respondent's Information")}
                        </TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      {this.props.caseData.a9 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Name")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a9}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a16 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Address")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a16}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a12 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Identity Number")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a12}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a14 !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Address")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a14}
                          </TableCell>
                        </TableRow>
                      )}

                      {/* {this.props.respondent_address !== undefined &&
                                    <TableRow hover style={{ height: 16 }}>
                                        <TableCell className={classes.row} component="th" scope="row">
                                            {this.context.t("Address")}:
                                        </TableCell>
                                        <TableCell className={classes.row} align="left">
                                        {this.props.respondent_address}
                                        </TableCell>
                                    </TableRow>} */}

                      {this.props.caseData.a16a !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("E-mail")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.props.caseData.a16a}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.caseData.a16b !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Telephone No")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {(this.props.caseData.a16b).replace("852","852 ") }
                          </TableCell>
                        </TableRow>
                      )}

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        ></TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.rowBold}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Payment Status")}:
                        </TableCell>
                        <TableCell
                          className={classes.row}
                          align="left"
                        ></TableCell>
                      </TableRow>

                      {this.props.claimantPayment !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Claimant")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.context.t("Paid")}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.respondentPayment !== undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Respondent")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            {this.context.t("Paid")}
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.claimantPayment == undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Claimant")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            --
                          </TableCell>
                        </TableRow>
                      )}

                      {this.props.respondentPayment == undefined && (
                        <TableRow hover style={{ height: 16 }}>
                          <TableCell
                            className={classes.row}
                            component="th"
                            scope="row"
                          >
                            {this.context.t("Respondent")}:
                          </TableCell>
                          <TableCell className={classes.row} align="left">
                            --
                          </TableCell>
                        </TableRow>
                      )}

                      {/* <TableRow hover style={{ height: 16 }}>
                        <TableCell
                          className={classes.row}
                          component="th"
                          scope="row"
                        >
                          {this.context.t("Deadline to next step")}:
                        </TableCell>
                        <TableCell className={classes.row} align="left">
                          {this.context.t("6 days")}
                        </TableCell>
                      </TableRow> */}
                         
                          
                    </TableBody>
                  </Table>
                  <SelectedArbitrators/>
                  <DeadlinePanel/>
                  {(this.state.typeOfAccount == "admin" || this.state.typeOfAccount == "arbitrator") && process.env.REACT_APP_MODE === "ts" && <TimerPanel caseData={this.props.caseData}/>}
                  {/* {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <LoginRecords/>}
                  {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <SMSStatus/>}
                  {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <EmailReadStatus/>}
                  {this.state.typeOfAccount == "admin" && process.env.REACT_APP_MODE === "ts" && <SentEmailStatus/>} */}
                      
                </Grid>

                {/* {this.state.typeOfAccount !== "admin" && this.state.typeOfAccount !== "arbitrator" && canChooseArbitrator && this.props.caseData.arbitratorStatus !== 'true' && 
                <Grid item spacing={2} md={6} lg={6} sm={6} xs={12}>
                  <ChooseArbitratorForCaseInformation />
                </Grid>} */}
              </Grid>

            </div>
          );
        }
        
      }
    }
  }
}

const mapStateToProps = (state) => {
  // console.log('mapStateToProps: state: ' + JSON.stringify(state));
  return {
    isLoading: state.caseInfo.loading,
    error: state.caseInfo.error,
    conversationId: state.caseInfo.conversationId,
    caseId: state.caseInfo.caseId,
    status: state.caseInfo.status,
    agreement_type: state.caseInfo.agreement_type,
    kind_of_claim: state.caseInfo.kind_of_claim,
    language: state.caseInfo.language,
    claimant_company_incorporation_location:
      state.caseInfo.claimant_company_incorporation_location,
    claimant_email_address: state.caseInfo.claimant_email_address,
    claimant_made_loan_as: state.caseInfo.claimant_made_loan_as,
    claimant_registered_address: state.caseInfo.claimant_registered_address,
    agreement_oral_or_written: state.caseInfo.agreement_oral_or_written,
    respondent_email_address: state.caseInfo.respondent_email_address,
    respondent_incorporation_company_location:
      state.caseInfo.respondent_incorporation_company_location,
    respondent_person_or_company: state.caseInfo.respondent_person_or_company,
    respondent_telephone: state.caseInfo.respondent_telephone,
    dater_entering: state.caseInfo.dater_entering,
    interest_or_not: state.caseInfo.interest_or_not,
    claimant_telephone: state.caseInfo.claimant_telephone,
    total_outstanding_loan: state.caseInfo.total_outstanding_loan,
    loan_payments: state.caseInfo.loan_payments,
    repayment_method: state.caseInfo.repayment_method,
    repayment_of_loan: state.caseInfo.repayment_of_loan,
    the_written_clause_amount_of_loan:
      state.caseInfo.the_written_clause_amount_of_loan,
    the_written_clause_rate_of_interest:
      state.caseInfo.the_written_clause_rate_of_interest,
    total_amount_of_loan: state.caseInfo.total_amount_of_loan,
    written_clause_term_of_repayment:
      state.caseInfo.written_clause_term_of_repayment,
    did_respondent_make_other_payment:
      state.caseInfo.did_respondent_make_other_payment,
    repeated_request: state.caseInfo.repeated_request,
    resolve_by: state.caseInfo.resolve_by,
    claimant_name: state.caseInfo.claimant_name,
    claimant_hkid: state.caseInfo.claimant_hkid,
    claimant_passport: state.caseInfo.claimant_passport,
    claimant_address: state.caseInfo.claimant_address,
    respondent_name: state.caseInfo.respondent_name,
    respondent_hkid: state.caseInfo.respondent_hkid,
    respondent_passport: state.caseInfo.respondent_passport,
    respondent_registered_address: state.caseInfo.respondent_registered_address,
    respondent_address: state.caseInfo.respondent_address,
    claimant_steps_completed: state.caseInfo.claimant_steps_completed,
    respondent_steps_completed: state.caseInfo.respondent_steps_completed,
    finished: state.caseInfo.finished,
    claimantUniqueId: state.caseInfo.claimantUniqueId,
    respondentUniqueId: state.caseInfo.respondentUniqueId,
    claimantPayment: state.caseInfo.claimantPayment,
    respondentPayment: state.caseInfo.respondentPayment,
    claimantArbitratorName: state.caseInfo.claimantArbitratorName,
    respondentArbitratorName: state.caseInfo.respondentArbitratorName,
    caseData: state.caseInfo.caseData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCaseInfo: (caseId) => dispatch(actions.getCaseInfo(caseId)),
    getUserInformation: (uniqueId) => dispatch(actions.getUserInformation(uniqueId)),
  };
};

CaseInformation.contextTypes = {
  t: PropTypes.func,
};

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(CaseInformation)
);
